export default __webpack_public_path__ + "static/media/uche.b893a4d0.png";